import auth0, { Auth0Error } from 'auth0-js';

const domain = process.env.REACT_APP_AUTH0_DOMAIN as string;
const clientID = process.env.REACT_APP_AUTH0_CLIENT_ID as string;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE as string;
const issuerBaseUrl = process.env?.REACT_APP_AUTH0_ISSUER_BASE_URL;

export const webAuth = new auth0.WebAuth({
  domain: domain,
  clientID: clientID,
  redirectUri: window.location.origin + '/callback',
  responseType: 'token id_token',
  scope: 'openid profile email',
  audience: audience,
  ...(issuerBaseUrl && { issuer: issuerBaseUrl }),
});

export const startAuth0Passwordless = (email: string, sendType: "link" | "code"): Promise<unknown> => {
  console.log("debug",domain);
  return new Promise((resolve, reject) => {
    webAuth.passwordlessStart({
      connection: 'email',
      send: sendType,
      email: email,
      authParams: {
        responseType: 'token id_token',
        redirectUri: window.location.origin + '/callback',
        scope: 'openid profile email',
        audience: audience
      }
    }, (err: Auth0Error | null, res: unknown) => {
      if (err) {
        reject(new Error(err.errorDescription || err.description || `Failed to send magic ${sendType}`));
      } else {
        resolve(res);
      }
    });
  });
};